/*
The <drag-anchor> directive will render as a draggable object.
The anchor itself is by default the dragged object.
An ancestor may be designated as the dragged object via the `anchors-to` attribute (a css selector).
When dragging an object, it will be given the `dragging` classname.
To be used in conjuction with the <drop-target> directive.

@example

  <div class='drag-me'>
    <drag-anchor anchors-to='.drag-me' />
  </div>

*/
import {v4 as createUuid} from 'uuid';

import './style.styl';

export default __filename;
angular.module(__filename, []).directive(
  'dragAnchor',
  ngInject(($rootScope) => ({
    restrict: 'AE',

    link(scope, el) {
      angular.element(el).addClass('drag-anchor');
      angular.element(el).attr('draggable', 'true');
      if (!angular.element(el).text()) {
        angular.element(el).text(':::');
      }

      const getDragSubject = function(subject) {
        const anchors = angular.element(el).attr('anchors-to');
        const dragSubject = anchors ? subject.closest(anchors) : subject;
        return dragSubject;
      };

      el.bind('dragstart', function(e) {
        const dragSubject = getDragSubject(e.currentTarget);
        let id = angular.element(dragSubject).attr('id');
        if (!id) {
          id = createUuid();
          angular.element(dragSubject).attr('id', id);
        }
        e.dataTransfer.setData('text', id);
        e.dataTransfer.setDragImage(dragSubject, 0, 25);
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.dropEffect = 'move';
        angular.element(dragSubject).addClass('dragging');
        return $rootScope.$emit('DRAG-START');
      });

      return el.bind('dragend', function(e) {
        const dragSubject = getDragSubject(e.currentTarget);
        angular.element(dragSubject).removeClass('dragging');
        return $rootScope.$emit('DRAG-END');
      });
    },
  })),
);
